/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ original_yearly_price: NonNullable<unknown>, discount_yearly_price: NonNullable<unknown> }} Yearly_Subscription_BtnInputs */

const en_yearly_subscription_btn = /** @type {(inputs: Yearly_Subscription_BtnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Subscribe ${i?.original_yearly_price} ${i?.discount_yearly_price}/year`)
};

const ar_yearly_subscription_btn = /** @type {(inputs: Yearly_Subscription_BtnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`اشترك ${i?.original_yearly_price} ${i?.discount_yearly_price}/سنة`)
};

const de_yearly_subscription_btn = /** @type {(inputs: Yearly_Subscription_BtnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Abonnieren ${i?.original_yearly_price} ${i?.discount_yearly_price}/Jahr`)
};

const es_yearly_subscription_btn = /** @type {(inputs: Yearly_Subscription_BtnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Suscríbete por ${i?.original_yearly_price} ${i?.discount_yearly_price} / año`)
};

const fr_yearly_subscription_btn = /** @type {(inputs: Yearly_Subscription_BtnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Abonnement ${i?.original_yearly_price} ${i?.discount_yearly_price}/an`)
};

const it_yearly_subscription_btn = /** @type {(inputs: Yearly_Subscription_BtnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Abbonati a ${i?.original_yearly_price} ${i?.discount_yearly_price}/anno`)
};

const ja_yearly_subscription_btn = /** @type {(inputs: Yearly_Subscription_BtnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.original_yearly_price} ${i?.discount_yearly_price}/年で購読`)
};

const ko_yearly_subscription_btn = /** @type {(inputs: Yearly_Subscription_BtnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.original_yearly_price} ${i?.discount_yearly_price}/1년 가격으로 구독하기`)
};

const pt_br_yearly_subscription_btn = /** @type {(inputs: Yearly_Subscription_BtnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Inscreva-se por ${i?.original_yearly_price} ${i?.discount_yearly_price}/ano`)
};

const ru_yearly_subscription_btn = /** @type {(inputs: Yearly_Subscription_BtnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Подписывайтесь за ${i?.original_yearly_price} ${i?.discount_yearly_price}/год`)
};

const th_yearly_subscription_btn = /** @type {(inputs: Yearly_Subscription_BtnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`สมัครสมาชิก ${i?.original_yearly_price} ${i?.discount_yearly_price}/ปี`)
};

const tr_yearly_subscription_btn = /** @type {(inputs: Yearly_Subscription_BtnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Yıllık ${i?.original_yearly_price} ${i?.discount_yearly_price}'ya abone ol`)
};

const zh_cn_yearly_subscription_btn = /** @type {(inputs: Yearly_Subscription_BtnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`购买 ${i?.original_yearly_price} ${i?.discount_yearly_price}/年`)
};

const zh_tw_yearly_subscription_btn = /** @type {(inputs: Yearly_Subscription_BtnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`訂閱 ${i?.original_yearly_price} ${i?.discount_yearly_price}/年`)
};

/**
* | output |
* | --- |
* | "Subscribe {original_yearly_price} {discount_yearly_price}/year" |
*
* @param {Yearly_Subscription_BtnInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const yearly_subscription_btn = /** @type {((inputs: Yearly_Subscription_BtnInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Yearly_Subscription_BtnInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_yearly_subscription_btn(inputs)
	if (locale === "ar") return ar_yearly_subscription_btn(inputs)
	if (locale === "de") return de_yearly_subscription_btn(inputs)
	if (locale === "es") return es_yearly_subscription_btn(inputs)
	if (locale === "fr") return fr_yearly_subscription_btn(inputs)
	if (locale === "it") return it_yearly_subscription_btn(inputs)
	if (locale === "ja") return ja_yearly_subscription_btn(inputs)
	if (locale === "ko") return ko_yearly_subscription_btn(inputs)
	if (locale === "pt_br") return pt_br_yearly_subscription_btn(inputs)
	if (locale === "ru") return ru_yearly_subscription_btn(inputs)
	if (locale === "th") return th_yearly_subscription_btn(inputs)
	if (locale === "tr") return tr_yearly_subscription_btn(inputs)
	if (locale === "zh_cn") return zh_cn_yearly_subscription_btn(inputs)
	return zh_tw_yearly_subscription_btn(inputs)
});